/* Home: Hero slideshow. The main photo shows immediately; with more than
   one photo the stack cross-dissolves (900ms, see the CSS) to the next one
   every HOME_HERO_INTERVAL, looping. No click needed. Skipped for reduced
   motion, and paused while the tab is hidden.

   Each section keeps its timer in a WeakMap so `shopify:section:load` in the
   theme editor cancels a running loop instead of stacking a second one. */
const HOME_HERO_INTERVAL = 3500;
const HOME_HERO_REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
const homeHeroTimers = new WeakMap();

function initHomeHero(section) {
  clearInterval(homeHeroTimers.get(section));

  const slides = Array.from(section.querySelectorAll('.home-hero__slide'));
  let index = 0;
  slides.forEach((slide, i) => slide.classList.toggle('is-active', i === 0));
  if (slides.length < 2 || HOME_HERO_REDUCED_MOTION.matches) return;

  homeHeroTimers.set(
    section,
    setInterval(() => {
      if (document.hidden) return;
      index = (index + 1) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    }, HOME_HERO_INTERVAL)
  );
}

function initHomeHeroes(root) {
  root.querySelectorAll('[data-home-hero]').forEach(initHomeHero);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHomeHeroes(document));
} else {
  initHomeHeroes(document);
}

document.addEventListener('shopify:section:load', (event) => initHomeHeroes(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-home-hero]').forEach((section) => clearInterval(homeHeroTimers.get(section)));
});
